import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import mainPage from './modules/mainPage'
import editPage from './modules/editPage'
import notification from './modules/notification'
import interfacePage from './modules/interfacePage'
import interfaceText from './modules/interfaceText'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    siteDomainProd: 'https://www.slav-nayka.com',
    apiDomain: 'https://api.slav-nayka.com',
    /// apiDomain: 'http://127.0.0.1:8000', //
    siteDomain: 'https://slav-nayka.com:49010',
    ckfinderUrl: '/api/uploadCKEditorImage',
    notificationApiUrl: 'https://onesignal.com/api/v1/notifications',
    notificationApiKey: 'Basic Yzg5YzVlMDUtYzhlNi00MGY2LWI5ZDUtMmU5YmZjMDczMWFi',
    apiUrls: {
      content: '/api/contents',
      pages: '/api/pages',
      feedback: '/api/feedback'
    },
    menuDesktopShow: false,
    menuMobileShow: false,
    newReviews: {
      common: 0,
      malcev: 0,
      articles: 0
    },
    parentId: {
      blog: 5,
      activity: 97,
      authors: 19,
      albums: 34,
      seminars: 49,
      seminarsFree: 1648,
      photoReports: 48,
      courses: 55,
      experts: 79,
      lectures: 59,
      library: {
        free: 80,
        paid: 81,
        audio: 82,
        meters: 94,
        films: 83,
        recommendedFilms: 93
      },
      news: 117,
      quotes: 104,
      partners: 96,
      scientist: 97,
      descriptionPages: 95,
      diplomas: 103,
      settings: 1636
    },
    contentId: {
      activityCategories: 1893,
      blogCategories: 1892,
      seminarsCategories: 1894,
      lecturesCategories: 1895,
      filmsCategories: 1896
    },
    typeId: {
      reviews: {
        common: 2,
        feedback: 1,
        publications: 3,
        scientist: 4
      }
    },
    unreadMessages: 0,
    pagesUrl: {
      97: 'oleg-malcev/nauchnaya-deyatelnost',
      104: 'oleg-malcev/tsitaty',
      103: 'oleg-malcev/diplomy-i-sertifikaty',
      5: 'blog',
      49: 'video-otchoty', //'seminary',
      1648: 'kruglyj-stol', // 'besplatnye-seminary',
      93: 'rekomenduyemyye-filmy',
      59: 'lektsii-online',
      81: 'knigi-maltseva',
      80: 'umnyye-knigi',
      83: 'filmy',
      48: 'foto-otchoty',
      82: 'audioknigi',
      56: 'distantsionnyye-kursy',
      57: 'tehnologii',
      58: 'intensiv-kursy',
      79: 'nashi-eksperty',
      94: 'izmeriteli'
    },
  },
  mutations: {
    hideHeaderPopup(state) {
      state.showHeaderPopup = false
    },
    showMenuDesktop(state, flag) {
      state.menuDesktopShow = flag
    },
    toggleMenuMobile(state) {
      state.menuMobileShow = !state.menuMobileShow;
    },
    showMenuMobile(state, flag) {
      state.menuMobileShow = flag;
    },
    setNewReviews(state, value) {
      state.newReviews = value
    }
  },
  getters: {

  },
  actions: {
    toggleMenu({ state, commit }, { menuType }) {
      let _menuType, _menuTypeState

      if (menuType == 'desktop') {
        _menuType = 'Desktop'
        _menuTypeState = state.menuDesktopShow
      } else if (menuType == 'mobile') {
        _menuType = 'Mobile'
        _menuTypeState = state.menuMobileShow
      }
      if (!_menuTypeState) {
        localStorage.setItem('Menu' + _menuType + 'Exposed', 'true')
        commit('showMenu' + _menuType, true)
      } else {
        localStorage.setItem('Menu' + _menuType + 'Exposed', 'false')
        commit('showMenu' + _menuType, false)
      }
    },
    showMenu({ commit }, { menuType, flag }) {
      let _menuType

      if (menuType === 'desktop') {
        _menuType = 'Desktop'
      } else if (menuType === 'mobile') {
        _menuType = 'Mobile'
      }

      if (flag == true) {
        localStorage.setItem('Menu' + _menuType + 'Exposed', 'true')
        commit('showMenu' + _menuType, true)
      } else {
        localStorage.setItem('Menu' + _menuType + 'Exposed', 'false')
        commit('showMenu' + _menuType, false)
      }
    },
    checkMenuStateOnLoad({ commit }) {
      if (localStorage.getItem('MenuMobileExposed') === 'true')
        commit('showMenuMobile', true)
      else commit('showMenuMobile', false)
      if (localStorage.getItem('MenuDesktopExposed') === 'true')
        commit('showMenuDesktop', true)
      else commit('showMenuDesktop', false)
    },
    async getNewReviews({commit, state}) {
      let newReviews = {}
      await Vue.prototype.$http.get(`${state.apiUrls.feedback}/count?search=type_id:${state.typeId.reviews.common};is_viewed:0&searchJoin=and`)
        .then((res) => {newReviews.common = res.data.data})
      await Vue.prototype.$http.get(`${state.apiUrls.feedback}/count?search=type_id:${state.typeId.reviews.scientist};is_viewed:0&searchJoin=and`)
        .then((res) => {newReviews.malcev = res.data.data})
      await Vue.prototype.$http.get(`${state.apiUrls.feedback}/count?search=type_id:${state.typeId.reviews.publications};is_viewed:0&searchJoin=and`)
        .then((res) => {newReviews.articles = res.data.data})
      commit('setNewReviews', newReviews)
    }
  },
  modules: {
    auth,
    mainPage,
    editPage,
    notification,
    interfacePage,
    interfaceText
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js